import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor( 
    private authService: MsalService
  ) { }

  ngOnInit() {
    console.log("Logout Init");
    localStorage.clear();
    this.authService.logout();
  }
}
